<template>
    <div v-if="code">
        <span class="manufacturer">Kód produktu: <strong class="js-manufacturer">{{ code }}</strong></span>
    </div>
</template>

<script>
export default {
    props: {
        externalId: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            code: this.externalId,
        }
    },

    mounted() {
        this.$root.$on('setProduct', (data) => {
            this.code = data.externalId
        });
    },

    methods: {

    }
}
</script>
